import Crud from '../views/TipoEstabelecimento/Crud'
import Entity from '../views/TipoEstabelecimento/Add'

let routes = {
    path: '/tipo_estabelecimento',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_estabelecimento/add',
            name: 'NewCbo',
            component: Entity
        },
        {
            path: '/tipo_estabelecimento/edit/:id?',
            name: 'EditCbo',
            component: Entity
        },
        {
            path: '/tipo_estabelecimento',
            name: 'list-tipo-estabelecimento',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Estabelecimentos',
                breadcrumb: [
                    {
                        text: 'Tipos de Estabelecimentos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
